import UpdateInfoRoute from './UpdateInfoRoute';

export default UpdateInfoRoute;

